import OrderCargoOrderFinishedDownloadRequest, {
  OrderCargoOrderFinishedDownloadRequestOrder,
  OrderCargoOrderFinishedDownloadRequestPublicStatus,
} from "../../../../../api/raily/order/cargo-order/finished/download/order-cargo-order-finished-download-request";
import ExecutionStatus from "../../../../../types/execution-status";
import PublicStatus from "../../../../../types/public-status";
import OrderCargoOrderFinishedDownloadParams, {
  OrderCargoOrderFinishedDownloadParamsSortKey,
} from "./order-cargo-order-finished-download-params";

const createPublicStatus = (
  status: PublicStatus | undefined,
): OrderCargoOrderFinishedDownloadRequestPublicStatus | undefined => {
  switch (status) {
    case PublicStatus.PRIVATE:
      return OrderCargoOrderFinishedDownloadRequestPublicStatus.PRIVATE;
    case PublicStatus.PUBLIC:
      return OrderCargoOrderFinishedDownloadRequestPublicStatus.PUBLIC;
    case PublicStatus.PUBLISHED:
      return OrderCargoOrderFinishedDownloadRequestPublicStatus.PUBLISHED;
    default:
      return undefined;
  }
};

const createOrder = (
  order: OrderCargoOrderFinishedDownloadParamsSortKey | undefined,
): OrderCargoOrderFinishedDownloadRequestOrder | undefined => {
  switch (order) {
    case OrderCargoOrderFinishedDownloadParamsSortKey.ORDER_START_DATE_ASC:
      return OrderCargoOrderFinishedDownloadRequestOrder.START_TIME_ASC;
    case OrderCargoOrderFinishedDownloadParamsSortKey.ORDER_START_DATE_DESC:
      return OrderCargoOrderFinishedDownloadRequestOrder.START_TIME_DESC;
    case OrderCargoOrderFinishedDownloadParamsSortKey.INTERNAL_ORDER_ID_ASC:
      return OrderCargoOrderFinishedDownloadRequestOrder.HUMAN_ID_ASC;
    case OrderCargoOrderFinishedDownloadParamsSortKey.INTERNAL_ORDER_ID_DESC:
      return OrderCargoOrderFinishedDownloadRequestOrder.HUMAN_ID_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: OrderCargoOrderFinishedDownloadParams,
): OrderCargoOrderFinishedDownloadRequest => {
  return {
    internalOrderId: params.internalOrderId ? [params.internalOrderId] : [],
    address: params.address ? [params.address] : [],
    client: params.client ? [params.client] : [],
    taxi: params.taxi ? [params.taxi] : [],
    dispatch: params.dispatch ? [params.dispatch] : [],
    driver: params.driver ? [params.driver] : [],
    startAddress: params.pickupAddress ? [params.pickupAddress] : undefined,
    endAddress: params.destinationAddress ? [params.destinationAddress] : [],
    midAddress: params.intermediateAddress ? [params.intermediateAddress] : [],
    externalId: params.externalOrderId ? [params.externalOrderId] : [],
    passenger: params.passenger ? [params.passenger] : [],
    order: createOrder(params.sortKey),
    publicStatus: createPublicStatus(params.publicStatus),
    isApproved: params.isUrgent,
    isCancelled: params.executionStatus
      ? params.executionStatus === ExecutionStatus.CANCELLED
      : undefined,
    startTimeSince: params.orderStartDateFrom,
    startTimeTo: params.orderStartDateTo,
  };
};

const orderCargoOrderFinishedDownloadParamsFactory = {
  create,
};

export default orderCargoOrderFinishedDownloadParamsFactory;
